import { useSelector } from 'react-redux';
import { getAuthProps } from '@topconagriculture/auth';
import { useFarmId } from '../components/Widget/InventoryWidget/useFarmId';
import { useCallback } from 'react';
import { useSocketTopicSubscription } from '@topconagriculture/react-socket-notification';
import { WidgetType } from '../components/Widget/widget.types';
const widgetTypeToTopicMap = {
    [WidgetType.DELIVER_DEVIATION]: 'TMR:WIDGET_DELIVERIES',
    [WidgetType.LOAD_DEVIATION]: 'TMR:WIDGET_LOADS',
};
export const useDeviationSubscription = (widgetType, refetch) => {
    const user = useSelector(getAuthProps);
    const farmId = useFarmId();
    const recipients = [farmId, user.companyId, user.userId];
    const onMessage = useCallback(() => {
        refetch();
    }, [refetch, farmId]);
    useSocketTopicSubscription({ topic: widgetTypeToTopicMap[widgetType], recipients, onMessage });
};
//# sourceMappingURL=useDeviationSubscription.js.map